import { render, staticRenderFns } from "./working-policy-detail-info.vue?vue&type=template&id=bbd2eb24&scoped=true&"
import script from "./working-policy-detail-info.vue?vue&type=script&lang=js&"
export * from "./working-policy-detail-info.vue?vue&type=script&lang=js&"
import style0 from "./working-policy-detail-info.vue?vue&type=style&index=0&id=bbd2eb24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd2eb24",
  null
  
)

export default component.exports